import { render, staticRenderFns } from "./Panel.vue?vue&type=template&id=4c93d8f8&lang=pug&"
import script from "./Panel.vue?vue&type=script&lang=js&"
export * from "./Panel.vue?vue&type=script&lang=js&"
import style0 from "./Panel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c93d8f8')) {
      api.createRecord('4c93d8f8', component.options)
    } else {
      api.reload('4c93d8f8', component.options)
    }
    module.hot.accept("./Panel.vue?vue&type=template&id=4c93d8f8&lang=pug&", function () {
      api.rerender('4c93d8f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/virtualrowFSFB/components/Panel.vue"
export default component.exports